/**
 * Validates a value is a mongodb object id.
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null
 * @name objectId
 * @memberof combinators
 */
async function validate(value, context) {
  // always pass on a null input
  if (value === undefined || value === null) {
    return Promise.resolve(null);
  }

  return Promise.resolve(/^[a-f\d]{24}$/i.test(value) ? null : 'not-an-objectid');
}

module.exports = validate;